var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 33h1.55V22H23.3Zm.7-13.7q.45 0 .75-.3t.3-.75q0-.5-.3-.8-.3-.3-.75-.3-.5 0-.775.3t-.275.8q0 .45.3.75t.75.3ZM24 42q-3.75 0-7-1.425T11.3 36.7Q8.85 34.25 7.425 31 6 27.75 6 24t1.425-7.025q1.425-3.275 3.875-5.7 2.45-2.425 5.7-3.85Q20.25 6 24 6t7.025 1.425q3.275 1.425 5.7 3.85 2.425 2.425 3.85 5.7Q42 20.25 42 24q0 3.75-1.425 7t-3.85 5.7q-2.425 2.45-5.7 3.875Q27.75 42 24 42Zm.05-1.55q6.8 0 11.6-4.8t4.8-11.7q0-6.8-4.775-11.6T24 7.55q-6.85 0-11.65 4.775Q7.55 17.1 7.55 24q0 6.85 4.8 11.65 4.8 4.8 11.7 4.8ZM24 24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageInfo);
export default __webpack_public_path__ + "static/media/image-info.8ba71ac37b3041c84362b0689e284bb1.svg";
export { ForwardRef as ReactComponent };